import * as React from "react"
import Button from "../components/Button"

export default function Tag({to, text, btnClass = ""}) {
  return (
    <Button to={to} className={`${btnClass} tag bg-color-golden c-purple-1 round my-2 me-2 dib`}>
      {text}
    </Button>
  )
}